module.exports = __webpack_public_path__ + "static/media/revenue.0eb893b1.svg";